import React from "react";
import { Card, CardBody, Col, Row, Badge } from "reactstrap";
import { Link } from "react-router-dom";

const SHORTCUTS = [
  {
    to: "/surucu-hakedis",
    icon: "bx bx-send",
    color: "text-success",
    label: "Sürücüye Öde",
  },
  {
    to: "/borc-yonetimi",
    icon: "bx bx-import",
    color: "text-primary",
    label: "Borç / Tahsilat",
  },
  {
    to: "/invoices-list",
    icon: "bx bx-file",
    color: "text-warning",
    label: "Faturalar",
  },
];

const FinansIstatistikleri = ({ stats, user, growthPct }) => {
  const positive = (growthPct ?? 0) >= 0;
  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody className="bg-primary-subtle rounded-top">
        <div className="d-flex">
          <div className="me-4">
            <i className="mdi mdi-shield-account text-primary h1" />
          </div>
          <div className="flex-grow-1">
            <div className="text-primary">
              <h5 className="text-primary fw-bold">{user?.Users_NameSurname || "Yönetici"}</h5>
              <p className="mb-1">{user?.Users_Email}</p>
              <Badge color="primary">LojGo Sistem Yöneticisi</Badge>
            </div>
          </div>
        </div>
      </CardBody>

      <CardBody className="border-top">
        <Row>
          <Col sm="6">
            <div>
              <p className="text-muted mb-2 fw-semibold">Sistemdeki İşlem Hacmi</p>
              <h5 className="text-success fw-bold">
                {Number(stats?.totalRevenue || 0).toLocaleString("tr-TR")} TL
              </h5>
            </div>
          </Col>
          <Col sm="6">
            <div className="text-sm-end mt-4 mt-sm-0">
              <p className="text-muted mb-2 fw-semibold">Aylık Değişim</p>
              <h5 className="fw-bold">
                {growthPct == null ? (
                  <span className="text-muted">—</span>
                ) : (
                  <>
                    {positive ? "+" : ""}%{Math.abs(growthPct).toFixed(1)}
                    <Badge color={positive ? "success" : "danger"} className="ms-2 align-bottom">
                      <i className={`mdi mdi-arrow-${positive ? "up" : "down"}`} />
                      {positive ? " Artış" : " Düşüş"}
                    </Badge>
                  </>
                )}
              </h5>
            </div>
          </Col>
        </Row>
      </CardBody>

      <CardBody className="border-top">
        <p className="text-muted mb-4 fw-semibold">Hızlı Finansal Kısayollar</p>
        <Row className="text-center g-0">
          {SHORTCUTS.map((s) => (
            <Col sm="4" key={s.to}>
              <Link to={s.to} className="text-decoration-none">
                <div className="p-2 rounded shortcut-hover">
                  <div className={`font-size-24 ${s.color} mb-2`}>
                    <i className={s.icon} />
                  </div>
                  <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
                    {s.label}
                  </p>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default FinansIstatistikleri;
